import urls from '../../../util/urls';
import featuresActionTypes from './actionTypes';
import { Dispatch } from 'redux';

export interface Feature {
  feature: string;
  value?: boolean;
}

export interface FeatureParams {
  project?: string;
  tag?: string;
}

function fetchFeatures(params: FeatureParams = { tag: 'phc-ui' }) {
  return (dispatch: Dispatch) => {
    return dispatch({
      type: featuresActionTypes.FETCH_FEATURES,
      url: urls.api.features(params),
    });
  };
}

function fetchUnauthFeatures() {
  return (dispatch: Dispatch) => {
    return dispatch({
      type: featuresActionTypes.FETCH_UNAUTH_FEATURES,
      url: urls.api.publicFeatures({ tag: 'phc-ui' }),
    });
  };
}

export type ToggleFeatureLocalPersistOptions = {
  skipLocalPersist?: boolean;
};

function toggleFeature(
  feature: string,
  value?: boolean,
  options?: ToggleFeatureLocalPersistOptions,
) {
  return {
    type: featuresActionTypes.TOGGLE_FEATURE,
    feature,
    value,
    meta: options,
  };
}

function toggleFeatures(
  features: Feature[],
  options?: ToggleFeatureLocalPersistOptions,
) {
  return {
    type: featuresActionTypes.TOGGLE_FEATURES,
    features,
    meta: options,
  };
}

export default {
  fetchFeatures,
  fetchUnauthFeatures,
  toggleFeature,
  toggleFeatures,
};
